﻿import { AsYouType, parsePhoneNumber } from 'libphonenumber-js';

window.AsYouType = AsYouType;
window.parsePhoneNumber = parsePhoneNumber;
